import { observable, action, runInAction} from 'mobx'
import { message } from 'antd'
import { json } from '../../../../utils/ajax'

class easyReportApprovalStore {

    @observable directory
    @observable contents
    @observable loading
    @observable options
    @observable selectType //ture快讯
    @observable list
    @observable pagination
    @observable catalogId //选择简报
    @observable carId //选择的车系
    @observable search //查询参数
    @observable modal
    @observable forms
    @observable contentId
    @observable record
    @observable content
    @observable articleId
    @observable carseries

    constructor () {
        this.initStore()
    }

    @action initStore = () => {
        this.options = []
        this.directory = []
        this.contents = []
        this.carseries = []
        this.loading = false
        this.selectType = true
        this.pagination = {
            current: 1,
            total: 10,
        }
        this.search = {}
        this.list = []
        this.catalogId = ''
        this.modal = 'noShow'
        this.forms = {}
        this.record = []
        this.content = {}
        this.articleId = ''
    }

    //Tree
    @action
    initDirectory = async (id) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${id}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    @action emptySelect = () => {
        runInAction(() => {
                this.brands = {
                    list: [],
                    selected: ''
                }
                this.carSeries = {
                    list: [],
                    selected: ''
                }
            }
        )
    }
    @action empetyDirectory = () => {
        runInAction(() => {
                this.directory = []
                this.list = []
            }
        )

    }
    @action empetyContents = () => {
        runInAction(() => {
                this.contents = []
            }
        )

    }

    @action changerList=()=>{
        runInAction(() => {
            this.list=[]
        })
    }

    @action changeSelectType = (id, boolean) => {
        runInAction(() => {
                this.selectType = boolean
                this.carId = id
            }
        )
    }

    @action
    onSearchFieldChange (values) {
        runInAction(() => {
                Object.keys(values).forEach(key => {
                    this.search[key] = values[key] ? values[key].value : ''
                })
            }
        )
    }

    @action
    initSearchField (values) {
        runInAction(() => {
                this.search = values
                this.catalogId = values.catalogId
            }
        )
    }

    @action initList = async (page) => {
        runInAction(() => {
            this.loading = true
        })

        if (page) {
            page--
        } else if (this.pagination.current) {
            page = (this.pagination.current - 1).toString()
        } else {
            page = '0'
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.search).forEach(key => {
            search[`search.${key}`] = this.search[key] ? this.search[key] : ''
        })
        search.page = page
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontents:approval`, search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.list = res.content
            this.loading = false
        })
    }

    @action refreshPage = () => {
        runInAction(() => {
            this.pagination = {
                current: 1,
                total: 10,
            }
            this.search = {}
        })
    }

    @action showModal = (flag, record) => {
        runInAction(() => {
            this.modal = flag ? 'show' : 'hide'
            this.record = record
        })
        this.initArticle(1)
    }

    @action
    initArticle = async (id) => {
        if (this.record === undefined) {
            return
        }
        id = this.record.id
        runInAction(() => {
            this.loading = true
            this.articleId = id
            this.content = {}
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent?id=` + id)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.content = res
            this.loading = false
        })
    }

    // 审批通过/审批驳回/重置审批
    @action
    approvalOption = async (key) => {

        //审批通过
        if (key === '1') {
            if (this.record.approval !== 3) {
                message.error('不处于待审状态！')
                return
            }
            const id = this.record.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent/updateApproval/` + id + `/4`)
            await this.initList(this.pagination.page)
            message.success('审批通过！')
        } else
        // 审批驳回
        if (key === '2') {
            if (this.record.approval===5){
                message.error('内容已发布无法返回')
                return
            }
            const id = this.record.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent/updateApproval/` + id + `/2`)
            await this.initList(this.pagination.page)
            message.success('审批已驳回！')
        }
    }

    @action
    publish = async (id, state) => {
        let res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent:update`, {
            'id': id,
            'approval': state

        })
        if (res && res.status === 0) {
            message.error('操作失败')

            return
        }else {
            message.success('成功')
            await this.initList(this.pagination.page)
        }
    }

    /**
     * 初始化车系
     */
    @action initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

}

export default new easyReportApprovalStore()



// WEBPACK FOOTER //
// ./src/Backend/dongfeng/Briefing/BriefingApproval/store.js